import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdxErpReportActionService {
  private readonly http = inject(HttpClient);

  resetErp(adxInvoiceId: number): Observable<void> {
    return this.http.put<void>('dbov2/adx-invoice/reset-adx-invoice-erp', {adxInvoiceId});
  }

  /**
   * Payload is fetched only when opened, so the report grid never carries the raw JSON.
   * The endpoint is declared [Produces(application/json)], so the body is a JSON string
   * literal -- left as responseType 'text' it would reach the dialog still carrying its
   * surrounding quotes and unicode escapes. Parsing it as JSON hands back the stored text.
   */
  getPayload(adxInvoiceId: number): Observable<string> {
    return this.http.get<string>(`dbov2/adx-invoice/${adxInvoiceId}/payload`);
  }
}
